export default __webpack_public_path__ + "51e61567f7425b46d4463da4e20aface.png";